// import {Statistics} from "./Statistics.tsx";
import highlighted from "../../assets/highlighted.jpg";
import {useTranslation} from "react-i18next";

export const About = () => {
    const {t} = useTranslation();

    return (
        <section
            id="about"
            className="container py-24 sm:py-32"
        >
            <div className="bg-muted/50 border rounded-lg py-12">
                <div className="px-6 flex flex-col-reverse md:flex-row gap-8 md:gap-12">
                    <img
                        src={highlighted}
                        alt=""
                        className="w-[300px] object-contain rounded-lg"
                    />
                    <div className="bg-green-0 flex flex-col justify-between">
                        <div className="pb-6">
                            <h2 className="text-3xl md:text-4xl font-bold">
                                {t("landing.aboutApp")}
                            </h2>
                            <p className="text-muted-foreground mt-4">
                                {t("landing.aboutAppDescLine1")}
                            </p>
                            <p className="text-muted-foreground mt-2">
                                {t("landing.aboutAppDescLine2")}
                            </p>
                            <p className="text-muted-foreground mt-2">
                                {t("landing.aboutAppDescLine3")}
                            </p>
                            <p className="text-muted-foreground mt-2">
                                {t("landing.aboutAppDescLine4")}
                            </p>
                            <p className="text-muted-foreground mt-2">
                                {t("landing.aboutAppDescLine5")}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
